import { render, staticRenderFns } from "./ReschedulePage.vue?vue&type=template&id=c5ddffe6&scoped=true&"
import script from "./ReschedulePage.vue?vue&type=script&lang=js&"
export * from "./ReschedulePage.vue?vue&type=script&lang=js&"
import style0 from "./ReschedulePage.vue?vue&type=style&index=0&id=c5ddffe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ddffe6",
  null
  
)

export default component.exports